export const getImageSnapshotButtons = ({ viewController }) => {
    const views = [];

    const dependentViews = [];

    viewController.blueprint.views.forEach((v) => {
        if (v.custom && v.custom['v-also-show']) {
            dependentViews.push(v.custom['v-also-show']);
        }
    });

    viewController.blueprint.views.forEach((view) => {
        if (dependentViews.includes(view.code)) {
            return;
        }

        if (!view.productionReady && view.bakeInRecipe) {
            let bakedFrame;

            if (view.bakedFrame) {
                ({ bakedFrame } = view);
            } else {
                if (view.viewType === 'Single') {
                    bakedFrame = view.frameLow;
                }
                if (view.viewType === 'Range') {
                    bakedFrame = view.frameLow;
                }
            }

            let url = viewController.makeFrameUrl(view, viewController.state, bakedFrame, {
                baking: true,
            });

            url += '&fmt=jpg&qlt=95';

            url = url.replace('rhei=600&', '');
            url = url.replace('rwid=500&', '');

            views.push({
                name: view.name,
                url,
            });
        }
    });

    return views;
};

export default { getImageSnapshotButtons };
